const keyWords = ["null", "true", "false"]
export default keyWords
